import { ReactComponent as LoadingSpinnerSVG } from "@svg/loading_spinner.svg";
import { GenericComponentProps, makeStyles } from "../../../utils/genericComponentProps";

export type LoadingIndicatorProps = GenericComponentProps & {
  className?: string;
  id?: string;

  centerHorizontally?: boolean;
};

export const LoadingIndicator = ({ className, id, centerHorizontally, ...props }: LoadingIndicatorProps) => {
  const style = makeStyles(props);

  if (centerHorizontally) {
    style.marginLeft = "auto";
    style.marginRight = "auto";
  }

  return (
    <div
      id={id}
      style={{ display: "flex", alignItems: "center", justifyContent: "center", ...style }}
      className={"loading-indicator " + className}
      data-cy="loading-indicator"
    >
      <LoadingSpinnerSVG />
    </div>
  );
};
